import {
  ActivateListenerPayload,
  OptimizelyContext,
  OptimizelyProvider,
  createInstance,
  enums,
} from '@optimizely/react-sdk';
import { PropsWithChildren, useContext } from 'react';

import config from '../config';
import { useAuthenticatedUser } from '../hooks/useAuthenticatedUser';
import { v4 } from 'uuid';
import { waitUntilHeapLoaded } from '../utils/heap';

export const optimizelyInstance = createInstance({
  sdkKey: config.optimizelySdkKey,
});

configureHeapIntegration();

export const CustomOptimizelyProvider = ({ children }: PropsWithChildren) => {
  const { accessToken } = useAuthenticatedUser();

  return (
    <OptimizelyProvider
      optimizely={optimizelyInstance}
      user={{
        id: getUserId(accessToken?.guid),
      }}
    >
      {children}
    </OptimizelyProvider>
  );
};

export function useOptimizely() {
  return useContext(OptimizelyContext);
}

function configureHeapIntegration() {
  optimizelyInstance.notificationCenter.addNotificationListener<
    ActivateListenerPayload
  >(enums.NOTIFICATION_TYPES.ACTIVATE, payload => {
    waitUntilHeapLoaded().then(() => {
      const experimentKey = `experiment_${payload.experiment.key}`;
      window.heap?.addUserProperties({
        [experimentKey]: payload.variation.key,
      });
    });
  });
}

function getUserId(userId?: string): string {
  const key = 'jg_optimizely_user_id';
  let id = localStorage.getItem(key);

  if (!id) {
    id = userId ?? optimizelyInstance.getVuid() ?? v4();
    localStorage.setItem(key, id);
  }

  return id;
}
